export const useInitials = (name?: string) => {
  const parts = name?.split(' ') || []
  return parts.map((part) => (part.length > 0 ? part[0] : '')).join('')
}
